import React from "react";
import RouteTransferType from "@Route/features/transportType/types/RouteTransfer.type";
import TicketPrice from "@MyTickets/components/TicketPrice";
import IconUserOutline from "@Icons/user/IconUserOutline";

interface PriceInfoProps {
    isIntermodal: boolean,
    isCancelled: boolean,
    routeTransferTypeArray: RouteTransferType[],
    priceInCurrency: string,
    numberOfPassengers: number,
}

function PriceInfo(props: PriceInfoProps) {
    const {
        isIntermodal,
        isCancelled,
        routeTransferTypeArray,
        priceInCurrency,
        numberOfPassengers,
    } = props

    return (
        <TicketPrice
            isIntermodal={isIntermodal}
            routeTransferTypeArray={routeTransferTypeArray}
            priceInCurrency={priceInCurrency}
            isCancelled={isCancelled}
        >
            <span className="pax-number gb--label gb--label-default route--price-pax">
                <IconUserOutline
                    width="12"
                    height="12"
                />
                {numberOfPassengers}
            </span>
        </TicketPrice>
    );
}

export default PriceInfo